/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.47.0-rc(21007360cad28648bdf46282a2592cb47c3a7a6f)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.es", {
	"vs/base/common/platform": [
		"_",
	],
	"vs/editor/common/languages": [
		"matriz",
		"booleano",
		"clase",
		"constante",
		"constructor",
		"enumeración",
		"miembro de la enumeración",
		"evento",
		"campo",
		"archivo",
		"función",
		"interfaz",
		"clave",
		"método",
		"módulo",
		"espacio de nombres",
		"NULL",
		"número",
		"objeto",
		"operador",
		"paquete",
		"propiedad",
		"cadena",
		"estructura",
		"parámetro de tipo",
		"variable",
		"{0} ({1})",
	]
});